import { useContext } from "react";

import { FilterDataContext } from "context/FilterDataContext";

const useFilterData = () => {
  const context = useContext(FilterDataContext);

  if (context === undefined) {
    throw new Error("useFilterData must be used within a FilterDataProvider");
  }

  return context;
};

export { useFilterData };
